import { colors } from '@components/theme';
import { Box, Button, Divider, Hidden, Typography } from '@material-ui/core';
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons';
import { Menus } from '@models/menu';
import React, { ReactNode } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { useCollapsed } from './MainLayoutContext';

export const MainSideMenuContent = ({
  items,
  disabled = false,
  children
}: {
  items: Menus;
  disabled: boolean;
  children?: ReactNode;
}): JSX.Element => {
  const [collapsed, setCollapsed] = useCollapsed();
  const location = useLocation();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, isNewTab: boolean, path: string) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (isNewTab && path) {
      event.preventDefault();
      window.open(path, '_blank')?.focus();
      return;
    }
  };

  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      {children ? children : null}
      <Box flexGrow={1} py={4} mx={collapsed ? 2 : 1}>
        {items.map(({ path, icon: Icon, title, source, isNewTab = false }) => {
          const active = path
            ? !!matchPath(location.pathname, {
                path: path,
                exact: false,
                strict: true
              })
            : false;

          return (
            <React.Fragment key={path}>
              {source && (
                <Box>
                  <Divider />
                  <Box mt={1} mx={2} hidden={collapsed}>
                    <Typography variant='subtitle2' className='label-text semiBold'>
                      {source}
                    </Typography>
                  </Box>
                </Box>
              )}
              <Link to={path} onClick={(event) => handleClick(event, isNewTab, path)}>
                <Box
                  display='flex'
                  alignItems='center'
                  my={3}
                  bgcolor={active ? colors.primary[50] : 'unset'}
                  color={active ? colors.primary.main : colors.secondary.main}
                  borderRadius={10}
                  height={42}
                  width={collapsed ? 42 : 'auto'}
                >
                  <Box mx={collapsed ? 'auto' : 2} display='flex' alignItems='center' justifyContent='center'>
                    <Icon />
                  </Box>
                  {!collapsed && (
                    <Typography variant='subtitle2' color={active ? 'primary' : 'secondary'}>
                      {title}
                    </Typography>
                  )}
                </Box>
              </Link>
            </React.Fragment>
          );
        })}
      </Box>
      <Hidden smDown>
        <Box p={2} display={'flex'} justifyContent={collapsed ? 'center' : 'flex-end'}>
          <Box width={38} height={38}>
            <Button
              className='flat-button rounded-circle-button primary-button'
              onClick={() => setCollapsed(!collapsed)}
            >
              {!collapsed ? <ArrowBackIosOutlined fontSize='small' /> : <ArrowForwardIosOutlined fontSize='small' />}
            </Button>
          </Box>
        </Box>
      </Hidden>
    </Box>
  );
};
